export const ACTIVOS = [
    900,
    1001, 1002, 1003, 1004, 1100, 1300,
    2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2100, 2300,
    3000, 3001, 3002, 3004, 3003, 3005, 3006, 3007, 3100, 3300,
    4000, 4001, 4002, 4003, 4004, 4005, 4006, 4007, 4008, 4009, 4010, 4011, 4012, 4013, 4070, 4071, 4200, 4300,
    5001, 5002, 5003, 5004, 5007, // 5005 https://jira-it2.inetpsa.com/browse/DRA-7123
    6000, 6001, 6002,
    7000, 7001, 7002, 7003, 7004, 7005, 7100,
    8001,
    9001, 9002, 9003, 9100, 9300,
    9901, 9902, 9903, 9904, 9905, 9906, 9907, 9908, 9909, 9910, 9911, 9912
];
